import cn from 'classnames';
import React from 'react';

import {RemoteImageWithBackground} from '@/components/Image';
import {twx} from '@/utils/tailwindUtils';

import {TopBannerGreeting, WelcomeContent} from '../components';
import useWelcomeTopBannerAnimation from '../HomePageTopBanner/hooks/useWelcomeTopBannerAnimation';
import DcxTopBannerDefaultContent from './components/DcxTopBannerDefaultContent';
import DcxTopBannerLoyaltyButtonsBar from './components/DcxTopBannerLoyaltyButtonsBar';
import DcxTopBannerLoyaltyContent from './components/DcxTopBannerLoyaltyContent';
import useDcxTopBanner, {DCX_TOP_BANNER_TYPES} from './hooks/useDcxTopBanner';

const DcxTopBanner = ({id}) => {
    const {
        bannerGreetingRef,
        welcomeGreetingRef,
        isWelcomeModeInProgress,
        isAnimationStarted,
        startAnimation,
        translation,
        bannerAnimationClassName,
        greetingAnimationClassName,
        greetingAnimationStyle,
        bannerContentAnimationClassName,
        loyaltyButtonsBarAnimationClassName,
    } = useWelcomeTopBannerAnimation();
    const {bannerData, bannerType, onClick, loyaltyButtons} = useDcxTopBanner({id});

    if (!bannerData) return null;

    const {images} = bannerData || {};
    const isLoyaltyButtonsBarEnabled = loyaltyButtons?.length;

    return (
        <div
            className={cn(
                'relative -mb-2 bg-romance md:mb-6 md:bg-transparent',
                isLoyaltyButtonsBarEnabled && 'md:mb-0 md:pb-12'
            )}
        >
            <div
                className={twx(
                    'relative h-[515px] w-full font-bold text-romance md:h-[434px] xl:h-[604px] 2xl:h-[749px]',
                    bannerAnimationClassName
                )}
            >
                <RemoteImageWithBackground
                    className='left-0 top-0 h-full w-full shrink-0 animate-fade-in'
                    imgClassName='object-cover object-top'
                    imageMedia={images}
                />
                <TopBannerGreeting
                    greetingRef={bannerGreetingRef}
                    animationClassName={greetingAnimationClassName}
                    animationStyle={greetingAnimationStyle}
                />
                <div
                    className={twx(
                        'absolute bottom-8 left-0 right-0 max-w-2xl px-4 text-start md:px-8 lg:px-16 xl:mx-auto xl:box-content',
                        isLoyaltyButtonsBarEnabled ? 'md:bottom-28' : 'md:bottom-16',
                        bannerContentAnimationClassName
                    )}
                >
                    {bannerType === DCX_TOP_BANNER_TYPES.LOYALTY && (
                        <DcxTopBannerLoyaltyContent bannerData={bannerData} />
                    )}
                    {bannerType === DCX_TOP_BANNER_TYPES.LOYALTY_NO_DEVICES && (
                        <DcxTopBannerDefaultContent bannerData={bannerData} onClick={onClick} />
                    )}
                    {bannerType === DCX_TOP_BANNER_TYPES.DEFAULT && (
                        <DcxTopBannerDefaultContent bannerData={bannerData} />
                    )}
                </div>
                {isWelcomeModeInProgress && (
                    <WelcomeContent
                        isAnimationStarted={isAnimationStarted}
                        onClick={startAnimation}
                        greetingRef={welcomeGreetingRef}
                        greetingTranslation={translation}
                    />
                )}
            </div>
            {isLoyaltyButtonsBarEnabled && (
                <div
                    className={twx(
                        'w-full max-w-[2040px] px-4 md:absolute md:bottom-0 md:left-0 md:right-0 md:mx-auto md:px-8 lg:px-16',
                        loyaltyButtonsBarAnimationClassName
                    )}
                >
                    <DcxTopBannerLoyaltyButtonsBar buttons={loyaltyButtons} />
                </div>
            )}
        </div>
    );
};

export default DcxTopBanner;
